import type { IReportPeriod, IReportUser } from './IReportPeriod'

/** `GET /services/reports/logisticians_financial` (`SPEC-027` §3.3, §5.1). */
export const LOGISTICIANS_FINANCIAL_REPORT_URL = '/services/reports/logisticians_financial'

/** Білий список сортування бека (`GetLogisticiansFinancialReportAction::SORT_FIELDS`). */
export const LOGISTICIANS_FINANCIAL_SORT_FIELDS = ['applications', 'profit', 'percentage'] as const

export type LogisticiansFinancialSortField = (typeof LOGISTICIANS_FINANCIAL_SORT_FIELDS)[number]

export interface ILogisticiansFinancialTotals {
    applications: number
    /** Гривня, 2 знаки — округлює бек. */
    profit: number
    /** Частка у прибутку компанії, 1 знак після коми. */
    percentage: number
}

export interface ILogisticiansFinancialRow extends ILogisticiansFinancialTotals {
    user: IReportUser
}

export interface ILogisticiansFinancialReport {
    period: IReportPeriod
    rows: ILogisticiansFinancialRow[]
    /** «Разом» рахує бек (ЗВ-08): відсоток — Σ прибутку рядків / прибуток компанії. */
    total: ILogisticiansFinancialTotals
    companyProfit: number
}
